<template>
    <div class="uk-width-medium">
        <p class="uk-margin-small-bottom uk-text-center uk-text-uppercase">Product Search</p>
        <div class="uk-margin-small uk-flex uk-flex-left">
            <div id="search-holder">
                <label class="sr-only" for="search-products-input">Enter Product Name</label>
                <input id="search-products-input" v-model="searchTerm" class="uk-input uk-width-medium uk-form-small uk-text-left" name="search-products-input" style="color: #fff; background: #2d6d6d; border: 1px solid #fff;" type="text" @input="searchProducts">
                <ul v-if="products.length" id="filtered-suggestions" class="uk-list uk-width-large uk-text-left">
                    <li v-for="(s,i) in products" :key="i" class="uk-width-large" style="color: #fff;" @click="selectProduct(s)">{{ s[searchSuggestionsKey] }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
import * as CONFIG from 'cw-conf'
import {ref} from 'vue'
import {useDebounceFn} from "@vueuse/core";

const searchTerm = ref('')
const products = ref([])
const searchSuggestionsKey = 'title';

async function getDataFromServer() {
    await axios.get(CONFIG.SERVER_AJAX_URL + '/product/get-products-autocomplete', {
        params: {
            q: searchTerm.value,
            outdoor_only: 0
        }
    }).then(res => {
        products.value = res.data
    })
}

const searchProducts = useDebounceFn(() => {
    if (searchTerm.value === '') {
        return;
    }

    getDataFromServer()
}, 250)

function selectProduct(item) {
    window.location.href = '/product/detail/' + item.slug;
}
</script>

<style scoped>
#search-holder {
    position: relative;
    background: #fff;
}

#filtered-suggestions {
    padding: 15px 10px;
    background: #2d6d6d;
    color: #fff;
    z-index: 90;
    display: block;
    position: absolute;
    top: 9px;
    left: 0;
    border: 1px solid #fff;
    cursor: pointer;
}
</style>
